import styled from 'styled-components';
import { fontUi } from '../../theme/typography';

export const StyledBellWrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const StyledBellButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.headerText};
  cursor: pointer;
  opacity: 0.9;
  &:hover {
    opacity: 1;
    background: ${({ theme }) => theme.headerHover || 'rgba(255,255,255,0.08)'};
  }
`;

export const StyledBellDot = styled.span`
  position: absolute;
  top: 7px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #de3e32;
  box-shadow: 0 0 0 2px ${({ theme }) => theme.header};
`;

export const StyledBellPanel = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: min(320px, 80vw);
  max-height: 360px;
  overflow: auto;
  padding: 8px 0;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
`;

export const StyledBellEmpty = styled.p`
  ${fontUi};
  margin: 0;
  padding: 16px;
  font-size: 13px;
  color: ${({ theme }) => theme.textFaint};
  text-align: center;
`;

export const StyledBellItem = styled.div`
  padding: 10px 14px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  &:last-child {
    border-bottom: 0;
  }
`;

export const StyledBellText = styled.div`
  ${fontUi};
  font-size: 13px;
  line-height: 1.35;
  color: ${({ theme }) => theme.text};
`;

export const StyledBellTime = styled.div`
  ${fontUi};
  margin-top: 4px;
  font-size: 11px;
  color: ${({ theme }) => theme.textFaint};
`;
